import React, {Component} from 'react';
import {Button, Modal, TextArea} from 'semantic-ui-react';
import cloneDeep from 'lodash';
import './confirmation.scss';

class EnablePriceChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'displayConfirmationModal': false,
      'priceEditionReason': '',
    };
    this.handleInputPriceChangeReason = this.handleInputPriceChangeReason.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onEditPriceConfirmClick = this.onEditPriceConfirmClick.bind(this);
    this.handleEnablePriceEdition = this.handleEnablePriceEdition.bind(this);
  }

  handleEnablePriceEdition() {
    const stateCopy = cloneDeep(this.state);
    stateCopy.displayConfirmationModal = true;
    this.setState(stateCopy);
  }

  handleInputPriceChangeReason(event, data) {
    this.setState({'priceEditionReason': data.value.toUpperCase()});
  }

  onCloseModalClick() {
    this.setState({'displayConfirmationModal': false});
    this.setState({'priceEditionReason': ''});
  }

  onEditPriceConfirmClick() {
    const {handleEnablePriceEditionClick} = this.props;
    const {priceEditionReason} = this.state;
    this.setState({'displayConfirmationModal': false});
    handleEnablePriceEditionClick(priceEditionReason);
  }

  renderChangePriceButton() {
    const {isPriceEditionEnabled} = this.props;
    return (
      <Button primary
        onClick={this.handleEnablePriceEdition}
        disabled={isPriceEditionEnabled}
      >
        Cambiar precio
      </Button>
    );
  }

  renderConfirmationModal() {
    const {displayConfirmationModal, priceEditionReason} = this.state;
    if (!displayConfirmationModal) {
      return null;
    }

    return (
      <Modal size='tiny' open={displayConfirmationModal}>
        <Modal.Header>
          Confirmación
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p className='message'>Por favor ingrese la justificación del cambio de precio para poder continuar</p>
            <TextArea style={{'width': '-webkit-fill-available'}}
              onInput={this.handleInputPriceChangeReason}
              maxLength={100}>
            </TextArea>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          <Button positive
            onClick={this.onEditPriceConfirmClick}
            disabled={!priceEditionReason.length}
          >
            Cambiar precio
          </Button>
        </Modal.Actions>

      </Modal>
    );
  }

  render() {
    return (
      <div>
        {this.renderConfirmationModal()}
        {this.renderChangePriceButton()}
      </div>
    );
  }
}

export default EnablePriceChange;
